var _ellipse, _ellipse2, _ellipse3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResolution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 196,
    viewBox: "0 0 195 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.4021,
    cy: 97.5772,
    rx: 96.9021,
    ry: 97.0772,
    stroke: "#FFAFB7",
    strokeOpacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.4021,
    cy: 97.5773,
    rx: 77.2977,
    ry: 77.4374,
    stroke: "#FFEB99",
    strokeOpacity: 0.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.4021,
    cy: 97.5773,
    rx: 57.7293,
    ry: 57.8336,
    stroke: "#FFAFB7",
    strokeOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14933_19741)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.0296 84.6089L105.836 96.3795L106.98 113.918C106.98 113.918 89.7088 114.116 89.6853 113.926C89.6618 113.736 92.1332 85.3691 92.1332 85.3691L94.0296 84.6089Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.0296 84.6089L105.836 96.3795L106.98 113.918C106.98 113.918 89.7088 114.116 89.6853 113.926C89.6618 113.736 92.1332 85.3691 92.1332 85.3691L94.0296 84.6089Z",
    fill: "url(#paint0_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.0296 84.6089L105.836 96.3795L106.98 113.918C106.98 113.918 89.7088 114.116 89.6853 113.926C89.6618 113.736 92.1332 85.3691 92.1332 85.3691L94.0296 84.6089Z",
    fill: "url(#paint1_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0296 84.6089L105.836 96.3795L106.98 113.918C106.98 113.918 89.7088 114.116 89.6853 113.926C89.6618 113.736 92.1332 85.3691 92.1332 85.3691L94.0296 84.6089Z",
    fill: "url(#paint2_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.277 113.823L108.196 114.856L107.873 116.098L106.893 114.229L105.783 96.8956L110.277 113.823Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5876 135.805L103.75 134.921L106.418 122.413L108.214 115.653L107.225 113.755L89.6655 113.765L92.1702 131.11L96.5876 135.805Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.5876 135.805L103.75 134.921L106.418 122.413L108.214 115.653L107.225 113.755L89.6655 113.765L92.1702 131.11L96.5876 135.805Z",
    fill: "url(#paint3_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M96.5876 135.805L103.75 134.921L106.418 122.413L108.214 115.653L107.225 113.755L89.6655 113.765L92.1702 131.11L96.5876 135.805Z",
    fill: "url(#paint4_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5957 120.237L84.4564 99.6226L91.826 84.8809L89.3418 113.699L83.5957 120.237Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.5957 120.237L84.4564 99.6226L91.826 84.8809L89.3418 113.699L83.5957 120.237Z",
    fill: "url(#paint5_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter5_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.7517 130.678L83.8771 122.519L83.5842 120.145L89.3095 113.809L91.7517 130.678Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter6_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5054 122.098L80.5818 120.609L83.8788 131.812L79.6538 135.604L69.4414 133.249L67.4336 128.411L68.5054 122.098Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.5054 122.098L80.5818 120.609L83.8788 131.812L79.6538 135.604L69.4414 133.249L67.4336 128.411L68.5054 122.098Z",
    fill: "url(#paint6_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter7_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.546 131.358L91.1958 138.759L92.7307 136.707L95.8817 136.319L80.2131 120.654L83.546 131.358Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M83.546 131.358L91.1958 138.759L92.7307 136.707L95.8817 136.319L80.2131 120.654L83.546 131.358Z",
    fill: "url(#paint7_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M83.546 131.358L91.1958 138.759L92.7307 136.707L95.8817 136.319L80.2131 120.654L83.546 131.358Z",
    fill: "url(#paint8_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter8_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.7258 135.264L90.1311 148.048L87.8 144.145L91.6288 138.962L84.1144 131.62L79.7258 135.264Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M79.7258 135.264L90.1311 148.048L87.8 144.145L91.6288 138.962L84.1144 131.62L79.7258 135.264Z",
    fill: "url(#paint9_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter9_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0619 132.332L90.5222 151.077L92.0002 151.252L89.9927 147.793L79.5495 134.574L69.0619 132.332Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.0619 132.332L90.5222 151.077L92.0002 151.252L89.9927 147.793L79.5495 134.574L69.0619 132.332Z",
    fill: "url(#paint10_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.468 121.131C113.47 120.891 118.04 110.121 118.089 110.26C118.137 110.4 123.284 117.192 123.284 117.192L113.468 121.131Z",
    fill: "url(#paint11_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter10_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.714 123.232C105.857 122.995 107.929 115.17 107.929 115.17L117.854 110.288L112.797 120.881L105.714 123.232Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M105.714 123.232C105.857 122.995 107.929 115.17 107.929 115.17L117.854 110.288L112.797 120.881L105.714 123.232Z",
    fill: "url(#paint12_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter11_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.183 143.826C108.259 143.659 112.678 120.439 112.678 120.439L123.198 116.497L115.207 145.393L105.948 152.965L108.183 143.826Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.183 143.826C108.259 143.659 112.678 120.439 112.678 120.439L123.198 116.497L115.207 145.393L105.948 152.965L108.183 143.826Z",
    fill: "url(#paint13_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter12_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.414 122.322L103.726 134.952L109.018 143.429L113.329 120.003L106.414 122.322Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M106.414 122.322L103.726 134.952L109.018 143.429L113.329 120.003L106.414 122.322Z",
    fill: "url(#paint14_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M106.414 122.322L103.726 134.952L109.018 143.429L113.329 120.003L106.414 122.322Z",
    fill: "url(#paint15_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6349 143.703L92.7879 136.273L102.96 135.019L108.218 143.528L94.397 139.228L87.6349 143.703Z",
    fill: "url(#paint16_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter13_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.128 152.943L108.25 143.789L94.4312 139.505L87.6679 143.971L93.0986 153.517L106.128 152.943Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.128 152.943L108.25 143.789L94.4312 139.505L87.6679 143.971L93.0986 153.517L106.128 152.943Z",
    fill: "url(#paint17_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.183 143.826C108.259 143.659 112.678 120.439 112.678 120.439L123.198 116.497L115.207 145.393L105.948 152.965L108.183 143.826Z",
    fill: "url(#paint18_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.183 143.826C108.259 143.659 112.678 120.439 112.678 120.439L123.198 116.497L115.207 145.393L105.948 152.965L108.183 143.826Z",
    fill: "url(#paint19_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.276 57.5839L143.176 58.9171L137.686 74.6451L139.155 81.7859L144.241 76.7924L146.276 57.5839Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.276 57.5839L143.176 58.9171L137.686 74.6451L139.155 81.7859L144.241 76.7924L146.276 57.5839Z",
    fill: "url(#paint20_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.276 57.5839L143.176 58.9171L137.686 74.6451L139.155 81.7859L144.241 76.7924L146.276 57.5839Z",
    fill: "url(#paint21_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.706 56.5582L141.018 59.5476L141.303 58.3924L142.71 57.1614L146.104 56.1986L148.706 56.5582Z",
    fill: "url(#paint22_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter16_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.172 76.6448L147.762 77.2634L149.964 75.6334L148.609 56.5368L146.141 57.5648L144.172 76.6448Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.172 76.6448L147.762 77.2634L149.964 75.6334L148.609 56.5368L146.141 57.5648L144.172 76.6448Z",
    fill: "url(#paint23_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.325 60.0445L137.566 75.1871L143.416 59.2958L141.325 60.0445Z",
    fill: "url(#paint24_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter17_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.45 81.7998L133.485 86.7826L130.561 85.6978L140.023 50.8833L141.077 50.9695L141.762 57.7359L140.988 58.4771L137.037 74.6503L138.45 81.7998Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.45 81.7998L133.485 86.7826L130.561 85.6978L140.023 50.8833L141.077 50.9695L141.762 57.7359L140.988 58.4771L137.037 74.6503L138.45 81.7998Z",
    fill: "url(#paint25_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.45 81.7998L133.485 86.7826L130.561 85.6978L140.023 50.8833L141.077 50.9695L141.762 57.7359L140.988 58.4771L137.037 74.6503L138.45 81.7998Z",
    fill: "url(#paint26_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.422 75.5786L135.33 52.2621L138.487 48.8361L140.499 51.2825L131.572 83.8519L126.47 83.6726L123.422 75.5786Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.422 75.5786L135.33 52.2621L138.487 48.8361L140.499 51.2825L131.572 83.8519L126.47 83.6726L123.422 75.5786Z",
    fill: "url(#paint27_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M123.422 75.5786L135.33 52.2621L138.487 48.8361L140.499 51.2825L131.572 83.8519L126.47 83.6726L123.422 75.5786Z",
    fill: "url(#paint28_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.422 75.5786L135.33 52.2621L138.487 48.8361L140.499 51.2825L131.572 83.8519L126.47 83.6726L123.422 75.5786Z",
    fill: "url(#paint29_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.686 48.8799L139.969 49.5598L141.953 51.7718L140.776 51.6841L138.686 48.8799Z",
    fill: "#FFEB99"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter19_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.105 77.411L137.65 96.8126L132.504 100.624L134.133 87.2058L139.09 82.3288L144.105 77.411Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.105 77.411L137.65 96.8126L132.504 100.624L134.133 87.2058L139.09 82.3288L144.105 77.411Z",
    fill: "url(#paint30_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.105 77.411L137.65 96.8126L132.504 100.624L134.133 87.2058L139.09 82.3288L144.105 77.411Z",
    fill: "url(#paint31_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter20_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.458 83.0579L127.397 96.5407L131.979 100.508L133.678 86.721L130.72 85.6244L131.38 83.1941L126.458 83.0579Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M126.458 83.0579L127.397 96.5407L131.979 100.508L133.678 86.721L130.72 85.6244L131.38 83.1941L126.458 83.0579Z",
    fill: "url(#paint32_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.458 83.0579L127.397 96.5407L131.979 100.508L133.678 86.721L130.72 85.6244L131.38 83.1941L126.458 83.0579Z",
    fill: "url(#paint33_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter21_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.811 76.327L143.497 90.8942L140.867 93.144L137.433 97.0258L144.016 77.353L147.606 77.9705L149.811 76.327Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.811 76.327L143.497 90.8942L140.867 93.144L137.433 97.0258L144.016 77.353L147.606 77.9705L149.811 76.327Z",
    fill: "url(#paint34_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.811 76.327L143.497 90.8942L140.867 93.144L137.433 97.0258L144.016 77.353L147.606 77.9705L149.811 76.327Z",
    fill: "url(#paint35_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5901 47.2205L81.2188 44.8597L86.5661 54.4358L83.6244 70.0042L76.2898 75.5385L61.9652 68.9956L62.2979 56.689L72.5901 47.2205Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.5901 47.2205L81.2188 44.8597L86.5661 54.4358L83.6244 70.0042L76.2898 75.5385L61.9652 68.9956L62.2979 56.689L72.5901 47.2205Z",
    fill: "url(#paint36_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.5901 47.2205L81.2188 44.8597L86.5661 54.4358L83.6244 70.0042L76.2898 75.5385L61.9652 68.9956L62.2979 56.689L72.5901 47.2205Z",
    fill: "url(#paint37_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5901 47.2205L81.2188 44.8597L86.5661 54.4358L83.6244 70.0042L76.2898 75.5385L61.9652 68.9956L62.2979 56.689L72.5901 47.2205Z",
    fill: "url(#paint38_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.011 53.9515L71.9386 47.1188L61.626 57.0701L59.011 53.9515Z",
    fill: "#F35C6B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter24_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7572 69.1164L47.4813 96.7688L43.758 83.4967L59.248 53.4924L62.0748 56.6797L61.7572 69.1164Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.7572 69.1164L47.4813 96.7688L43.758 83.4967L59.248 53.4924L62.0748 56.6797L61.7572 69.1164Z",
    fill: "url(#paint39_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7572 69.1164L47.4813 96.7688L43.758 83.4967L59.248 53.4924L62.0748 56.6797L61.7572 69.1164Z",
    fill: "url(#paint40_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7572 69.1164L47.4813 96.7688L43.758 83.4967L59.248 53.4924L62.0748 56.6797L61.7572 69.1164Z",
    fill: "url(#paint41_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter25_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0541 75.5635L61.3976 103.953L70.25 100.462L86.6017 68.7891L83.1064 69.7729L76.0541 75.5635Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.1271 75.0849L60.4699 103.474L69.3216 99.983L85.674 68.3101L82.1789 69.294L75.1271 75.0849Z",
    fill: "url(#paint42_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.1271 75.0849L60.4699 103.474L69.3216 99.983L85.674 68.3101L82.1789 69.294L75.1271 75.0849Z",
    fill: "url(#paint43_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.1271 75.0849L60.4699 103.474L69.3216 99.983L85.674 68.3101L82.1789 69.294L75.1271 75.0849Z",
    fill: "url(#paint44_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M85.855 54.3032L87.7849 60.8295L86.3234 69.328L82.6158 70.2563L85.855 54.3032Z",
    fill: "url(#paint45_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter26_i_14933_19741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5056 69.6036L75.7665 76.1205L61.3976 103.953L47.4813 96.7687L61.5056 69.6036Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.5064 69.6041L75.7665 76.1205L61.3967 103.953L47.4813 96.7687L61.5064 69.6041Z",
    fill: "url(#paint46_linear_14933_19741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5064 69.6041L75.7665 76.1205L61.3967 103.953L47.4813 96.7687L61.5064 69.6041Z",
    fill: "url(#paint47_linear_14933_19741)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_14933_19741",
    x: 89.6852,
    y: 84.6089,
    width: 17.2952,
    height: 29.3997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0425
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_14933_19741",
    x: 105.783,
    y: 96.8958,
    width: 4.49438,
    height: 19.2019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_14933_19741",
    x: 89.6654,
    y: 113.755,
    width: 18.5481,
    height: 22.0498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5537
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_14933_19741",
    x: 83.5957,
    y: 84.8809,
    width: 8.23035,
    height: 35.356,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_14933_19741",
    x: 83.5842,
    y: 113.809,
    width: 8.16748,
    height: 16.8691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_14933_19741",
    x: 67.4336,
    y: 120.609,
    width: 16.4452,
    height: 14.9956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_14933_19741",
    x: 80.2131,
    y: 120.654,
    width: 15.6686,
    height: 18.1052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_14933_19741",
    x: 79.7258,
    y: 131.62,
    width: 11.9031,
    height: 16.4282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_14933_19741",
    x: 69.0619,
    y: 132.332,
    width: 22.9382,
    height: 18.9197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_14933_19741",
    x: 105.714,
    y: 110.288,
    width: 12.1396,
    height: 12.9443,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_14933_19741",
    x: 105.948,
    y: 116.497,
    width: 17.2506,
    height: 36.4688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_14933_19741",
    x: 103.726,
    y: 120.003,
    width: 9.60303,
    height: 23.4255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_14933_19741",
    x: 87.668,
    y: 139.505,
    width: 20.582,
    height: 14.0127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.10052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_14933_19741",
    x: 137.686,
    y: 57.584,
    width: 8.59009,
    height: 24.2019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.69754
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_14933_19741",
    x: 144.172,
    y: 56.5369,
    width: 5.79199,
    height: 20.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.69754
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_14933_19741",
    x: 130.561,
    y: 50.8833,
    width: 11.201,
    height: 35.8994,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.69754
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_14933_19741",
    x: 123.422,
    y: 48.8362,
    width: 17.0767,
    height: 35.0159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.76662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_14933_19741",
    x: 132.505,
    y: 77.4111,
    width: 11.6002,
    height: 23.2134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.69754
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_14933_19741",
    x: 126.458,
    y: 83.0579,
    width: 7.22083,
    height: 17.4504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.69754
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_14933_19741",
    x: 137.433,
    y: 76.3271,
    width: 12.3777,
    height: 20.6987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.69754
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_i_14933_19741",
    x: 61.9652,
    y: 44.8596,
    width: 24.601,
    height: 30.679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.9846
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_i_14933_19741",
    x: 43.7579,
    y: 53.4924,
    width: 18.3169,
    height: 43.2764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.84084
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_i_14933_19741",
    x: 61.3976,
    y: 68.7891,
    width: 25.2041,
    height: 35.1643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.84084
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_i_14933_19741",
    x: 47.4813,
    y: 69.6035,
    width: 28.2853,
    height: 34.3496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46736
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14933_19741",
    x1: 108.418,
    y1: 116.961,
    x2: 95.4765,
    y2: 89.7088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14933_19741",
    x1: 92.7148,
    y1: 81.3584,
    x2: 101.844,
    y2: 108.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14933_19741",
    x1: 73.7496,
    y1: 97.9174,
    x2: 101.765,
    y2: 107.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14933_19741",
    x1: 114.402,
    y1: 76.7374,
    x2: 100.854,
    y2: 130.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFB7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14933_19741",
    x1: 118.509,
    y1: 164.632,
    x2: 91.7243,
    y2: 124.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14933_19741",
    x1: 93.5572,
    y1: 58.2923,
    x2: 87.2358,
    y2: 121.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFB7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14933_19741",
    x1: 83.9207,
    y1: 133.458,
    x2: 63.5161,
    y2: 123.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14933_19741",
    x1: 79.4173,
    y1: 118.258,
    x2: 90.2258,
    y2: 134.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14933_19741",
    x1: 101.14,
    y1: 130.206,
    x2: 86.2793,
    y2: 127.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF973C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF973C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14933_19741",
    x1: 83.7585,
    y1: 132.115,
    x2: 94.6625,
    y2: 154.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14933_19741",
    x1: 74.9028,
    y1: 158.856,
    x2: 85.3415,
    y2: 140.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF973C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14933_19741",
    x1: 122.929,
    y1: 109.426,
    x2: 112.633,
    y2: 121.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDA35A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14933_19741",
    x1: 119.609,
    y1: 128.734,
    x2: 90.9877,
    y2: 95.3485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF973C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14933_19741",
    x1: 114.953,
    y1: 136.349,
    x2: 151.044,
    y2: 175.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14933_19741",
    x1: 112.826,
    y1: 115.565,
    x2: 100.233,
    y2: 135.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14933_19741",
    x1: 85.3351,
    y1: 186.34,
    x2: 109.977,
    y2: 129.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14933_19741",
    x1: 93.5519,
    y1: 134.612,
    x2: 108.037,
    y2: 141.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDA35A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14933_19741",
    x1: 97.3745,
    y1: 139.142,
    x2: 109.947,
    y2: 157.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14933_19741",
    x1: 103.777,
    y1: 132.559,
    x2: 124.2,
    y2: 102.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14933_19741",
    x1: 103.777,
    y1: 132.559,
    x2: 164.844,
    y2: 139.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14933_19741",
    x1: 145.026,
    y1: 57.3081,
    x2: 134.779,
    y2: 87.3613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_14933_19741",
    x1: 148.985,
    y1: 68.0135,
    x2: 148.241,
    y2: 35.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_14933_19741",
    x1: 145.355,
    y1: 55.8186,
    x2: 144.369,
    y2: 60.2871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB752"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_14933_19741",
    x1: 156.727,
    y1: 31.1441,
    x2: 149.757,
    y2: 74.7666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFB7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_14933_19741",
    x1: 147.203,
    y1: 37.9816,
    x2: 145.112,
    y2: 73.5258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFB7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_14933_19741",
    x1: 141.708,
    y1: 51.1089,
    x2: 136.08,
    y2: 180.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF973C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_14933_19741",
    x1: 141.708,
    y1: 51.1089,
    x2: 136.08,
    y2: 180.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_14933_19741",
    x1: 117.45,
    y1: 79.5752,
    x2: 141.503,
    y2: 63.1657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_14933_19741",
    x1: 139.37,
    y1: 28.5155,
    x2: 135.301,
    y2: 75.3667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_14933_19741",
    x1: 128.944,
    y1: 45.1521,
    x2: 138.748,
    y2: 66.7464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_14933_19741",
    x1: 141.857,
    y1: 86.7372,
    x2: 123.73,
    y2: 133.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C0E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_14933_19741",
    x1: 141.545,
    y1: 89.5172,
    x2: 109.542,
    y2: 112.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_14933_19741",
    x1: 129.453,
    y1: 89.4103,
    x2: 130.161,
    y2: 111.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF973C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF973C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_14933_19741",
    x1: 131.201,
    y1: 91.7478,
    x2: 119.386,
    y2: 76.4572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_14933_19741",
    x1: 157.17,
    y1: 53.6215,
    x2: 143.852,
    y2: 93.0608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF973C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_14933_19741",
    x1: 131.08,
    y1: 91.3961,
    x2: 146.244,
    y2: 90.8764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_14933_19741",
    x1: 64.3791,
    y1: 74.2089,
    x2: 84.2786,
    y2: 60.4202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_14933_19741",
    x1: 87.7267,
    y1: 33.6505,
    x2: 78.0059,
    y2: 70.1116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_14933_19741",
    x1: 87.7267,
    y1: 33.6505,
    x2: 71.5729,
    y2: 53.9253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_14933_19741",
    x1: 56.9324,
    y1: 61.4644,
    x2: -75.2483,
    y2: 151.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_14933_19741",
    x1: 56.9324,
    y1: 61.4644,
    x2: -29.4682,
    y2: 56.6704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFB7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_14933_19741",
    x1: 54.2339,
    y1: 72.6049,
    x2: 97.1608,
    y2: 48.0179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF973C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_14933_19741",
    x1: 73.0742,
    y1: 105.586,
    x2: 80.5341,
    y2: 80.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_14933_19741",
    x1: 73.0742,
    y1: 105.586,
    x2: 80.5341,
    y2: 80.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFB7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_14933_19741",
    x1: 82.9047,
    y1: 63.173,
    x2: 77.7896,
    y2: 90.2322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF973C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_14933_19741",
    x1: 81.1805,
    y1: 50.872,
    x2: 86.5926,
    y2: 76.6705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB8A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_14933_19741",
    x1: 66.7016,
    y1: 82.2257,
    x2: 59.9043,
    y2: 101.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_14933_19741",
    x1: 68.2272,
    y1: 79.1599,
    x2: 53.2899,
    y2: 120.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFB7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14933_19741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    fill: "white",
    transform: "translate(35.9023 36.4487)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolution);
export default __webpack_public_path__ + "static/media/Resolution.5f14225cd7f70559395030bb04074357.svg";
export { ForwardRef as ReactComponent };